import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./utils/ProtectedRoute";
import { AuthProvider } from "./lib/AuthContext";
// Old Dashboard - kept for reference
// import Dashboard from "./pages/Dashboard";
import DashboardV2 from "./pages/DashboardV2";
import AgencyPerformance from "./pages/AgencyPerformance";
import Clients from "./pages/Clients";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/Signup";
import EditClient from "./pages/EditClient";
import Feedback from "./pages/Feedback";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Account from "./pages/Account";
import CalendarPage from "./pages/Calendar";
import SalesPage from "./pages/Sales";
import NotFoundPage from "./pages/NotFoundPage";
// import MyTeam from "./components/account/components/my-team";
// import Reports from "./components/account/components/reports";
import TeamMember from "./pages/TeamMember";
import KnowledgeBase from "./pages/KnowledgeBase";
import KnowledgeBaseArticle from "./pages/KnowledgeBaseArticle";
import CommissionTracking from "./pages/CommissionTracking";
import AgentPayoutHistory from "./pages/AgentPayoutHistory";
import AuditLog from "./components/account/components/audit-log";
import FederalPlans from "./pages/FederalPlans";
// import { AIChatbot } from "./components/ai-chatbot";
import FloatingActionMenu from "./components/footer/FloatingActionMenu";
// import TOTPVerification from "./pages/TotpVerification";

// Wrapper component to access location inside Router
const AppRoutes: React.FC = () => {
  const location = useLocation();

  // Force complete re-render on every navigation
  React.useEffect(() => {
    console.log("Route changed to:", location.pathname);
  }, [location.pathname]);

  return (
    <Routes key={location.pathname}>
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      {/* <Route path="/totp" element={<TOTPVerification />} /> */}

      {/* Old Dashboard route - kept for reference */}
      {/* <Route
        path="/"
        index
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      /> */}

      {/* Dashboard V2 - Main dashboard route */}
      <Route
        path="/"
        index
        element={
          <ProtectedRoute>
            <DashboardV2 />
          </ProtectedRoute>
        }
      />

      {/* Dashboard V2 - Legacy route (kept for backward compatibility) */}
      {/* <Route
        path="/dashboard-v2"
        element={
          <ProtectedRoute>
            <DashboardV2 />
          </ProtectedRoute>
        }
      /> */}

      <Route
        path="/agency-performance"
        index
        element={
          <ProtectedRoute>
            <AgencyPerformance />
          </ProtectedRoute>
        }
      />

      <Route
        path="/clients/*"
        element={
          <ProtectedRoute>
            <Clients />
          </ProtectedRoute>
        }
      />

      <Route
        path="/calendar"
        index
        element={
          <ProtectedRoute>
            <CalendarPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/sales/*"
        index
        element={
          <ProtectedRoute>
            <SalesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit-client/:id"
        element={
          <ProtectedRoute>
            <EditClient />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/password/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/two-factor-authentication/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/preferences/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/api-keys/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/team/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/reports/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/billing/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/audit-log/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/payout-history/"
        element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        }
      />

      <Route
        path="/team/:memberId"
        element={
          <ProtectedRoute>
            {/* <Account /> */}
            <TeamMember />
          </ProtectedRoute>
        }
      />

      <Route
        path="/knowledge-base"
        element={
          <ProtectedRoute>
            <KnowledgeBase />
          </ProtectedRoute>
        }
      />

      <Route
        path="/knowledge-base/:slug"
        element={
          <ProtectedRoute>
            <KnowledgeBaseArticle />
          </ProtectedRoute>
        }
      />

      <Route
        path="/feedback"
        element={
          <ProtectedRoute>
            <Feedback />
          </ProtectedRoute>
        }
      />

      <Route
        path="/commission-tracking"
        element={
          <ProtectedRoute>
            <CommissionTracking />
          </ProtectedRoute>
        }
      />

      <Route
        path="/federal-plans"
        element={
          <ProtectedRoute>
            <FederalPlans />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

const App: React.FC = () => (
  <AuthProvider>
    <Router>
      <AppRoutes />
      <FloatingActionMenu />
    </Router>
  </AuthProvider>
);

export default App;
